export { TabbedContent, type TabbedContentProps } from "./TabbedContent";
